import { render, staticRenderFns } from "./OrgProfile.vue?vue&type=template&id=0a38f5d4&scoped=true&"
import script from "./OrgProfile.vue?vue&type=script&lang=js&"
export * from "./OrgProfile.vue?vue&type=script&lang=js&"
import style0 from "./OrgProfile.vue?vue&type=style&index=0&id=0a38f5d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a38f5d4",
  null
  
)

export default component.exports